import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, filter } from "rxjs";

type ToastType = 'success' | 'warning' | 'error';

interface Toast {
  id: number;
  title: string;
  message: string;
  type: ToastType;
}

interface ToastConfig {
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  toasts$: BehaviorSubject<Toast[]>;
  timers$: BehaviorSubject<number | null>;

  constructor() {
    this.toasts$ = new BehaviorSubject<Toast[]>([]);
    this.timers$ = new BehaviorSubject<number | null>(null);
  }

  success(message: string, title: string | null = null, config: ToastConfig = {}): void {
    this.push('success', message, title, config);
  }

  warning(message: string, title: string | null = null, config: ToastConfig = {}): void {
    this.push('warning', message, title, config);
  }

  error(message: string, title: string | null = null, config: ToastConfig = {}): void {
    this.push('error', message, title, config);
  }

  private push(type: ToastType, message: string, title: string | null, config: ToastConfig): void {
    config.duration ??= 5000;

    const toast = {
      id: Date.now(),
      type,
      message,
      title
    } as Toast;

    this.timers$.next(toast.id);
    this.timers$.pipe(
      filter(value => value !== null),
      delay(config.duration),
    ).subscribe((value: number|null) => {
      const currentToasts = this.toasts$.getValue();
      this.toasts$.next(currentToasts.filter(toast => value !== toast.id));
    });

    const currentToasts = this.toasts$.getValue();
    this.toasts$.next([toast, ...currentToasts]);
  }

}
